<template lang="pug">
	div
		transition(name="fade")
			Loader(v-if="!company")
		transition(name="fade")
			Auth(v-if="company" :type="type" @changeState="setType" @done="onDone" :header="'Join ' + company.name" subheader="Create your account to join your team")
		
</template>

<script>
import Auth from "../templates/Auth";
import Loader from "../components/Loader";
import { ref, onMounted, computed } from "@vue/composition-api";
import { auth } from "../firebase.config";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "Invite",
  components: { Auth, Loader },
  computed: { ...mapGetters(["company"]) },
  methods: { ...mapActions(["signInWithGoogle", "test"]) },
  setup(props, { root }) {
    const type = ref("signUp");
    const companyId = ref("");
    const email = ref("");

    onMounted(() => {
      const id = root.$route.query.companyId;
      const queryEmail = root.$route.query.email;

      if (queryEmail) email.value = queryEmail;

      if (id) {
        companyId.value = id;
        root.$store.dispatch("getCompany", id);
      } else root.$router.push("/sign-in");

      if (auth.currentUser && auth.currentUser.email == queryEmail) onDone();
      else if (auth.currentUser && auth.currentUser.email != queryEmail)
        root.$store.dispatch("signOut", false);
    });

    function setType(state) {
      type.value = state;
    }

    const subheader = computed(() => {
      if (type.value === "signUp")
        return "Create your account to join your team";
    });

    function onDone() {
      root.$store.commit("SET_SIGNING_IN", true);

      const addToMembers = root.$store
        .dispatch("arrayUnion", {
          collection: "companies",
          id: companyId.value,
          array: "members",
          item: auth.currentUser.uid,
        })
        .then(() => {
          return root.$store.dispatch("getCompany", companyId.value);
        });

      const removeFromInvites = root.$store
        .dispatch("arrayDelete", {
          collection: "companies",
          id: companyId.value,
          array: "invites",
          item: email.value,
        })
        .then(() => true);

      const changeUserCompany = root.$store
        .dispatch("updateUser", {
          uid: auth.currentUser.uid,
          change: { companyId: companyId.value },
        })
        .then(() => true);

      Promise.all([addToMembers, removeFromInvites, changeUserCompany])
        .then(() => root.$store.dispatch("getData", companyId.value))
        .then(() => root.$router.push("/"))
        .then(() => Intercom("startTour", 115543));
    }

    return {
      type,
      setType,
      companyId,
      onDone,
      subheader,
    };
  },
};
</script>
<style lang="sass" scoped>
img
	height: 400px
</style>
